import { FilterAttribute, Filter } from "../components/layerControl/FilterModal";

const getRelevantDateFields = (treatmentType: string): string[] => {
  const t = (treatmentType || "").toLowerCase();
  if (t.includes("reveg")) return ["VegDate"];
  if (t.includes("graz")) return ["StartDate", "EndDate"];
  return ["EndDate"];
};

const evaluateDateFilter = (feature: any, filter: Filter): boolean => {
  const type = feature.properties?.Type || "";
  const dateFields = getRelevantDateFields(type);

  const filterDate = filter.value ? new Date(filter.value) : null;
  const filterDate2 = filter.value2 ? new Date(filter.value2) : null;

  return dateFields.some((field) => {
    const raw = feature.properties?.[field];
    if (!raw) return false;
    const d = new Date(raw);
    if (isNaN(d.getTime())) return false;

    switch (filter.operator) {
      case "equals":
        return filterDate ? d.getTime() === filterDate.getTime() : false;
      case "after":
        return filterDate ? d > filterDate : false;
      case "before":
        return filterDate ? d < filterDate : false;
      case "between":
        return filterDate && filterDate2
          ? d >= filterDate && d <= filterDate2
          : false;
      default:
        return true;
    }
  });
};

const evaluateTreatmentFilter = (feature: any, filter: Filter): boolean => {
  if (filter.attribute === "_date") {
    return evaluateDateFilter(feature, filter);
  }

  const value = feature.properties?.[filter.attribute];
  if (value === null || value === undefined) return false;

  switch (filter.operator) {
    case "equals":
      return String(value).toLowerCase() === String(filter.value).toLowerCase();
    case "contains":
      return String(value)
        .toLowerCase()
        .includes(String(filter.value).toLowerCase());
    default:
      return true;
  }
};

export const getTreatmentFilterAttributes = (
  rawSource: any
): FilterAttribute[] => {
  if (!rawSource) return [];

  let features: any[] | undefined;
  if (rawSource.type === "FeatureCollection" && rawSource.features) {
    features = rawSource.features;
  } else if (Array.isArray(rawSource)) {
    features = rawSource;
  }

  if (!features || features.length === 0) return [];

  const uniqueTypes = new Set<string>();
  features.forEach((f) => {
    const t = f.properties?.Type;
    if (t) uniqueTypes.add(String(t));
  });

  const typeAttribute: FilterAttribute = {
    value: "Type",
    label: "Treatment Type",
    type: "enum",
    enumValues: Array.from(uniqueTypes).sort(),
  };

  const dateAttribute: FilterAttribute = {
    value: "_date",
    label: "Date",
    type: "date",
  };

  return [typeAttribute, dateAttribute];
};

export const applyTreatmentFilters = (source: any, filters: Filter[]): any => {
  if (!source || filters.length === 0) return source;

  if (source.type !== "FeatureCollection" || !source.features) return source;

  const filteredFeatures = source.features.filter((feature: any) =>
    filters.every((filter) => evaluateTreatmentFilter(feature, filter))
  );

  return { ...source, features: filteredFeatures };
};
